import getSecondsOfToday from './getSecondsOfToday';

function getFilteredWidgetSlots(slots, widgetParams) {
  return slots.filter((slot) => true || typeof slot === 'number' && (widgetParams.date > new Date() || slot > getSecondsOfToday()));
}

export default getFilteredWidgetSlots;
